"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usesToggleBeet = exports.isUsesToggleSet = exports.isUsesToggleClear = exports.isUsesToggleNone = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const Uses_1 = require("./Uses");
const isUsesToggleNone = (x) => x.__kind === 'None';
exports.isUsesToggleNone = isUsesToggleNone;
const isUsesToggleClear = (x) => x.__kind === 'Clear';
exports.isUsesToggleClear = isUsesToggleClear;
const isUsesToggleSet = (x) => x.__kind === 'Set';
exports.isUsesToggleSet = isUsesToggleSet;
exports.usesToggleBeet = beet.dataEnum([
    ['None', beet.unit],
    ['Clear', beet.unit],
    [
        'Set',
        new beet.BeetArgsStruct([['fields', beet.fixedSizeTuple([Uses_1.usesBeet])]], 'UsesToggleRecord["Set"]'),
    ],
]);
//# sourceMappingURL=UsesToggle.js.map